const cloneDeep = require('lodash/cloneDeep');
const merge = require('lodash/merge');
// const get = require('lodash/get');
// const sortBy = require('lodash/sortBy');
// const groupBy = require('lodash/groupBy');

export default (context, inject) => {
	inject('lodash', { cloneDeep, merge });
};
